import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import apiService from './services/api';
import { BookingAssistant } from './components';

function BookingPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const prefillDate = searchParams.get('date') || null;
  const prefillTime = searchParams.get('time') || null;

  return (
    <BookingAssistant
      isOpen={true}
      embedded={true}
      onClose={() => navigate('/')}
      apiService={apiService}
      navigate={navigate}
      prefillDate={prefillDate}
      prefillTime={prefillTime}
    />
  );
}

export default BookingPage;
